(ns minorodata.components.home.core
  (:require [reagent.core :as reagent]
            [minorodata.app.handlers :refer [dispatch]]))


(defn welcome []
  (reagent/create-class
   {:display-name "home-screen"

    :constructor
    (fn []
      (dispatch [:app.events/navigate :overview]))

    :render
    (fn [] [:div])}))
